import { render } from "./TheSvgImages.vue?vue&type=template&id=6945a790"
import script from "./TheSvgImages.vue?vue&type=script&lang=js"
export * from "./TheSvgImages.vue?vue&type=script&lang=js"

import exportComponent from "/Users/konatsu/docker-static/speedo.devs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__